<template>
  <div class="product-page" v-if="cProData!=null">      

      <!-- old <preloader key="page-preloader" v-if="!pageReady || !curcategory" class=""/>-->
      <!-- old <br/><h2>{{pro_data.product.Name}}</h2>-->
      
      <catalog-top-menu></catalog-top-menu>

      <div class="py-3xl px-2xl el-size--large pro-page">
        
        <div class="col-img py-3xl">
            <img :src="getImageURL()"/>
        </div>
      
        <div class="col-desc py-2xl">
          <h1>{{product_item_data.product.ShortName}}</h1>
          <h3>{{product_item_data.product.CatalogNo}}</h3>
          <br/>
          
          <!-- Add to list -->
          <a class="addToCollection" @click="addToCollection()" >
            <i class="fal fa-folder-plus"></i>
            <span class="addText">{{localize('Add to list')}}</span>
          </a><br/><br/>
          
          <div class="features">
            <div v-for="(value, propertyName) in product_item_data.spec" class="feat_row" v-bind:key="propertyName">
                <div class="feat_name"><b>{{propertyName}}:</b></div>
                <div class="feat_val">{{value}}</div>
            </div>
          </div>
          <br/>
          
          <!--
          <div class="desc" v-if="product_item_data.product.Description!=null && product_item_data.product.Description.length>0">
            {{product_item_data.product.Description}}   
          </div>
          <br/>
          -->
          
          <!--
          <div class="link" v-if="product_item_data.product.PrintCatalog!=null && 
                                  product_item_data.product.PrintCatalog.length>0">
            <a :href="pdfURL" target="_blank">
              <i class="fal fa-file-pdf" aria-hidden="true"></i>
              <span class="pdfLinkName">{{getFileName(product_item_data.product.PrintCatalog)}}</span>
            </a>            
          </div>
          -->

          <div class="link">            
            <a :href="getPrductUserURL" target="_blank">
              <i class="fal fa-file-pdf" aria-hidden="true"></i>
              <span class="pdfLinkName">{{product_item_data.product.CatalogNo}} IFU</span>
            </a>            
          </div>
          
          <!--
          <iframe
            v-if="product_item_data.product.MediaVideo.length>0"
            :src="videoURL"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            class="video_frame"
          ></iframe>
          -->
          
        </div>
        
          <!--old <div class="link">
            <a href="https://www.mis-implants.com/upload/pdf/products/MIS_Conical_Connection_Guide.pdf" target="_blank">
              <i class="fal fa-file-pdf" aria-hidden="true"></i> <span>Conical Connection Pro Tips Guide</span></a>            
          </div>-->


        <!-- old
        <div class="col-links el-size--medium py-2xl">
          <links-list :children="pro_data.links" :title="getLinksListTitle()"></links-list>
        </div>
        -->
        <br/><br/>
        
        <!-- INCLUDED/RELATED ITEMS SECTION -->
        <div class="pt-2xl products-row" v-if="product_item_data.included.length>0">
          <products-row  
            title="Included Products" 
            :showCatNo="false"
            :items="product_item_data.included"></products-row>
        </div>
        <div class="pt-2xl products-row" v-if="product_item_data.related.length>0">
          <products-row 
            title="Related Products" 
            :showCatNo="true"
            :items="product_item_data.related"></products-row>
        </div>
        
      </div>
      

      <!--
      <div class="py-3xl layout-group grid-flex-wrap group ready page-component el-size--large">

        <div class="layout-group--partial left col-3 p-2xl product-img el-size--medium">
              <img :src="getImageURL()" style="max-width:95%;max-height:400px"/>
        </div>

        <div class="layout-group--partial left col-5 p-2xl product-info el-size--medium" >
          <h1>{{pro_data.product.CatalogNo}}</h1>
          <br/>
          <h2>{{pro_data.product.Name}}</h2>
          <br/>
          {{pro_data.product.Description}}   
          <br/><br/>
          <div v-for="(value, propertyName) in pro_data.spec">
              {{propertyName}} : {{value}} 
          </div>
       
        </div>


        <div class="layout-group--partial left col-4 p-2xl product-info el-size--medium">
          <links-list :children="pro_data.links" :title="getLinksListTitle()"></links-list>
        </div>
      </div>

      <div class="p-2xl" v-if="pro_data.included.length>0">
        <products-row title="Included Products" :items="pro_data.included"></products-row>
      </div>
      <div class="p-2xl" v-if="pro_data.related.length>0">
        <products-row title="Related Products" 
        :items="pro_data.related"></products-row>
      </div>
      -->
  </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from "vuex";
    import { fetchContent } from "@/utils";
    import CatalogTopMenu from '../components/catalog/CatalogTopMenu.vue';
    import ProductsRow from '../components/catalog/ProductsRow.vue';
    
    import LinksList from '../components/LinksList.vue';
import Content from '../components/content/Content.vue';

    export default {
    components: { CatalogTopMenu,ProductsRow,LinksList, Content },
        data() 
        {
            return {
              product_item_data:null
            };
        },
        async mounted() {
            this.resetPageLayout();
            this.initProductData();
            this.setPageReady(true);
        },
        computed: {
          ...mapGetters(["catalogCategories"]),
          ...mapState(["product_data", "pageReady"]),
          cProData() {
            if (!this.product_item_data) return null;
            return this.product_item_data;
          },
          pro_image()
          {
              return `${vm.$imageFolder}/catalog/products/large/${this.product_item_data.product.CatalogNo}.png`;
          },
          videoURL()
          {
              return 'https://www.youtube.com/embed/'+this.product_item_data.product.MediaVideo+'?rel=0';
          },
          pdfURL()
          {
            return 'https://www.mis-implants.com/upload/'+this.product_item_data.product.PrintCatalog;
          },
          getPrductUserURL()
          {
            return 'https://www.misimplants.qarad.eifu.online/mis/def/?keycode='+this.product_item_data.product.CatalogNo;
          }
        },
        methods: {
            ...mapActions(["resetPageLayout", "setPageReady","initRouteByPath","setItemToCollect","addItemToCollection"]),            
            addToCollection(){
              //this.setItemToCollect(this.pro_data.product.PRO_ID);
              this.addItemToCollection(this.product_item_data.product.PRO_ID);
            },
            getFileName(path)
            {
                var linkName = path.substring(1+path.lastIndexOf("/"));
                var re = new RegExp('_', 'g');
                linkName = linkName.replace(re, ' ');
                linkName = linkName.replace(".pdf","");
                return linkName;
            },
            async initProductData() 
            {
                let content = await this.initRouteByPath(this.$route.path);
                //this.product_data = content;
                this.product_item_data = content;
                //await this.initProductData(this.$route.path);
                //alert("content="+content);
                //console.log("sitemap content < ", content);
                //alert(content.product.CatalogNo);
            },
            getLinksListTitle()
            {
                return this.localize("learn_more");
            },      
            getImageURL()
            {
              return 'https://www.mis-implants.com/upload/catalog/products/large/'+
                      this.cProData.product.CatalogNo+'.png';
            },
        },
        watch: {
          '$route' (to, from) {
            this.resetPageLayout();
            this.initProductData();
            this.setPageReady(true);
          }
        }

    }

</script>

<style lang="stylus" scoped>
.privacy
  min-height 30vh
  padding-top 10vh
  padding-bottom 10vh
.product-img
  text-align center
</style>

<style lang="stylus">
.catalog-categories
  position sticky
  top 179px //146px Dubi added 33px for the top strip diff
  z-index 21
  background gray_1
  box-shadow 0px 2px 12px rgba(gray_7, 0.4)
  height 10vh
  _flex(row, nowrap, stretch, space-between)
  min-height 60px
  a
    flex 1
    position relative
    color gray_8
    transition background-color 0.3s ease-out
    border-right 1px solid gray_4
    _flex(row, nowrap, center,center)
    max-width 25%
    .inline-icon
      flex 0 0 15%
      max-width 15%
      line-height 1
    svg
      stroke gray_6
      transition stroke 0.3s ease-out
      +below(1400px)
        max-height 38px
    span
      flex none
      max-width 48%
      text-align left
      line-height 1.1
      // overflow hidden
      // text-overflow ellipsis
      // white-space nowrap
    &:first-child
      border-left 1px solid gray_4
    &.router-link-active
    &:hover
      background blue_primary
      svg
        stroke #fff
      span
        color #fff
  &__mobile
    position relative
    top initial
    transform none
    // height 30px
    _flex(row, wrap, flex-end, flex-end)
  &__list
    position absolute
    width 100%
    min-width 220px
    _flex(column, nowrap, flex-start, flex-start)
    border 1px solid gray_2
    background #fff
    top 100%
    z-index 9
    a
      _flex(row, nowrap, center, flex-start)
      width 100%
      text-align left
      &:nth-child(odd)
        background gray_2
      .inline-icon
        flex 0 0 10%
        line-height 1
        svg
          stroke gray_6
      span
        flex none
        width 100%
        font-size 14px
      &.router-link-active
      &:hover
        background #fff
        svg
          stroke blue_primary
    a,
    a:visited
      color gray_8
      // &:not(:last-child)
      //   marg('xl', bottom)
  &__cur
    border-bottom 1px solid gray_6
    i
      color gray_6
      font-size 90%
</style>


<style scoped>
.addToCollection
{
  cursor: pointer !important;
}
.addToCollection i
{
  font-size: 16px;
  position: relative; top:1px;
}
.addToCollection .addText
{
  color:#222;
  font-size: 14px;
  padding-left: 7px;
}
.addToCollection:hover .addText
{
  color:#31a9f6;
  font-size: 14px;
  padding-left: 7px;
}

  .pro-page
  {
    clear: both;
    background-color: #fff;
    display: block;
    width: 100%;
    min-height: 100vh;
  }
  .col-img
  {
    float: left;
    width: 27%;
    display: block;

    text-align: center;
  }
  .col-desc
  {
    float: left;
    width: 60%;
    display: block;
    padding-left:40px;
    padding-right:40px;
  }
  .col-links
  {
    float: left;
    width: 30%;
    display: block;
  }

  .col-img img
  {
      max-width: 100%;    
      max-height: 400px;
  }
  .video_frame
  {
    padding-top: 40px;
    width: 80%;
    height: 30vw;
  }

  .features
  {
    display: table;
  }
  .feat_row
  {
    display: table-row;
  }
  .feat_name
  {
    display: table-cell;
    width: auto;    
    background-color: #efefef;
    margin: 1px !important;
    border: solid 1px #fff;
    padding: 7px;
    font-size: 12px;    
    padding-right: 30px !important;
  }
  .feat_val
  {
    display: table-cell;
    padding-right: 30px !important;
    background-color: #fafafa;
    margin: 1px !important;
    border: solid 1px #fff;
    padding: 7px;
    font-size: 12px;        
  }
  .desc
  {
    padding-bottom: 5px;
  }
  .link
  {
    padding-top: 10px;
  }
  .pdfLinkName
  {
    padding-left: 10px;
  }

/* On screens that are 992px or less, set the background color to blue */
@media screen and (max-width: 992px) {
  .catalog-categories
  {
    display: none !important;
  }
  .product-main
  {
    clear: both;
    width: 100vw;
  }

  .col-img
  {
    clear:both;
    width: 100%;
    display:block;
    overflow: hidden;
  }
  .col-desc
  {
    float: initial;
    clear:both;
    width: 100%;
    display: block;
    padding: 0px !important;
    overflow: hidden;
  }
  .col-links
  {
    float: initial;
    clear:both;
    width: 100%;
    display: block;
    overflow: hidden;
  }  

  .products-row
  {
    padding: 0px !important;
  }

}

/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
}


</style>
